import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import { createHash, randomBytes } from "crypto";

export default class PINCode {
  constructor(req, res) {
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis(
      {
        host: process.env.REDIS_HOST || config.pincode.redis?.host,
        port: process.env.REDIS_PORT || config.pincode.redis?.port,
        keyPrefix: config.pincode.redis.prefix,
        db: config.pincode.redis?.db,
      },
      config.pincode?.redis?.cluster
    );
  }

  generatePINCode() {
    const randomNum = () => Math.floor(Math.random() * 10);
    return Array.from(Array(4)).map(randomNum).join("");
  }

  generateToken() {
    return randomBytes(32).toString("hex");
  }

  generateHash(key) {
    return createHash("sha256").update(key).digest("hex");
  }

  getToken() {
    return this.cookies.get(config.pincode.name);
  }

  async publish(key) {
    const pin = this.generatePINCode();
    const token = this.generateToken();
    const hash = this.generateHash(key);
    await this.redis
      .multi()
      .set(hash, JSON.stringify({ pin, token }))
      .expire(hash, config.pincode.maxAge)
      .exec();
    this.cookies.set([
      {
        name: config.pincode.name,
        value: token,
        option: {
          maxAge: config.pincode.maxAge,
        },
      },
    ]);
    return pin;
  }

  async verify(value, key) {
    const token = this.getToken();
    if (!token) return false;
    const hash = this.generateHash(key);
    const json = await this.redis.get(hash);
    if (!json) return false;
    const payload = JSON.parse(json);
    return payload?.pin === value && payload?.token === token;
  }

  async delete(key) {
    const hash = this.generateHash(key);
    await this.redis.del(hash);
    const token = this.getToken();
    if (!token) return false;
    this.cookies.remove([config.pincode.name]);
  }
}
